import { Injectable } from '@angular/core';
import { Effect, ofType, Actions } from '@ngrx/effects';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { ActionFailed } from '@tokeet-frontend/utility';
import { AiResponderService } from './ai-responder.service';
import { DeleteAIDocument, DeleteAIDocumentComplete, LoadAISettings, LoadAISettingsComplete, UpdateAISettings, UpdateAISettingsComplete } from './ai-settings.actions';
import { Toaster } from '@tokeet/tv3-platform';


@Injectable()
export class AISettingsEffects {
  @Effect()
  load$ = this.actions$.pipe(
    ofType(LoadAISettings),
    switchMap(() =>
      this.aiService.getSettings().pipe(
        map((settings) => LoadAISettingsComplete({ settings })),
        catchError((error) => of(ActionFailed({ error })))
      )
    )
  )

  @Effect()
  update$ = this.actions$.pipe(
    ofType(UpdateAISettings),
    switchMap(({ payload, message, silent }) =>
      this.aiService.updateSettings(payload).pipe(
        map(() => UpdateAISettingsComplete({ changes: payload })),
        tap(() => !silent && this.toaster.success(message || 'Settings updated successfully.')),
        catchError((error) => of(ActionFailed({ error })))
      )
    )
  )

  @Effect()
  deleteDoc$ = this.actions$.pipe(
    ofType(DeleteAIDocument),
    switchMap(({ id }) =>
      this.aiService.deleteFile(id).pipe(
        map(() => DeleteAIDocumentComplete({ id })),
        tap(() => this.toaster.success('Document deleted successfully.')),
        catchError((error) => of(ActionFailed({ error })))
      )
    )
  )

  constructor(
    private actions$: Actions,
    private toaster: Toaster,
    private aiService: AiResponderService,
  ) { }
}
